module.exports = __webpack_public_path__ + "img/mujeresygoce.00e4e616.jpg";